import request from '../httpClient';

export const getAirbnbListing = (listingId: number) =>
  request.get(`/listings/airbnb/${listingId}`);



// WEBPACK FOOTER //
// ./src/services/api/airbnbListingApi.ts